// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"83e1e597","416":"b851b56e","428":"bfb88142","508":"d3253785","693":"4f2cf403","855":"2de00152","860":"5335902a","965":"7ea19850","968":"9a5f05b2"}[chunkId] + ".chunk.js";
};